import { axiosInstance } from "@/core/http";

export const camerasApi = {
  // Camera Manufacturers
  getManufacturers: () => axiosInstance.get("/panel/camera-manufacturer/"),
  createManufacturer: (data) =>
    axiosInstance.post("/panel/camera-manufacturer/", data),
  updateManufacturer: (id, data) =>
    axiosInstance.put(`/panel/camera-manufacturer/${id}/`, data),
  deleteManufacturer: (id) =>
    axiosInstance.delete(`/panel/camera-manufacturer/${id}/`),

  // Camera Types (manufacturer + model)
  getCameraTypes: () => axiosInstance.get("/panel/camera-type/"),
  createCameraType: (data) => axiosInstance.post("/panel/camera-type/", data),
  updateCameraType: (id, data) =>
    axiosInstance.put(`/panel/camera-type/${id}/`, data),
  deleteCameraType: (id) => axiosInstance.delete(`/panel/camera-type/${id}/`),

  // Cameras (Playgrounds)
  getCameras: (params) => axiosInstance.get("/panel/playground/", { params }),
  createCamera: (data) => axiosInstance.post("/panel/playground/create/", data),
  updateCamera: (id, data) =>
    axiosInstance.put(`/panel/playground/${id}/`, data),
  deleteCamera: (id) => axiosInstance.delete(`/panel/playground/${id}/`),

  // Snapshot
  getSnapshot: (id) =>
    axiosInstance.post(`/panel/playground/${id}/snapshot/`, null, {
      responseType: "blob",
    }),

  // Field
  getFieldInfo: (id) => axiosInstance.get(`/panel/playground/${id}/field/`),
  updateField: (id, data) =>
    axiosInstance.post(`/panel/playground/${id}/field/update/`, data),
};
